// extracted by mini-css-extract-plugin
export default {"darkOverlay":"overlay_darkOverlay__xehlx"};